import { render, staticRenderFns } from "./StudioResetPassword.vue?vue&type=template&id=6d0b47b4&"
import script from "./StudioResetPassword.vue?vue&type=script&lang=ts&"
export * from "./StudioResetPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports